import Select from "react-select";

const tipoOptions = [{
    value: 0,
    label: 'Todos'
}, {
    value: 1,
    label: 'Farmacia'
}, {
    value: 2,
    label: 'Ambulatorio'
}]

export default function TiposSelect({ selectedEstado, setSelectedEstado }) {

    return (
        <Select
            options={tipoOptions}
            value={tipoOptions.find(opt => opt.value === selectedEstado)}
            onChange={(newEstado) => setSelectedEstado(newEstado.value)}
            placeholder="Seleccionar estado"
            styles={{
                control: (base, state) => ({
                    ...base,
                    borderColor: state.isFocused ? "#B04708" : "#ced4da",
                    boxShadow: state.isFocused
                        ? "0 0 0 1px #B04708"
                        : base.boxShadow,
                    outline: "none",
                    "&:hover": {
                        borderColor: state.isFocused ? "#B04708" : "#adadad",
                    },
                }),
                option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isSelected
                        ? "#B04708"
                        : state.isFocused && !state.isDisabled
                            ? "#fff2f0ff"
                            : "white",
                    color: state.isDisabled
                        ? "#aaa"
                        : state.isSelected
                            ? "white"
                            : "#333",
                }),
            }}
        />
    );
}
